import React from "react";
import GridView from "../../../components/gridview/GridView";
import PageTitle from "../../../utils/page-title";
import { connect } from "react-redux";
import { withAllMatches } from "../../../components/mediaquery/breakpoints";
import { selectors as bridgeSelectors } from "../../../../redux/bridge";
import { t } from "../../../core/translate";
import PromotionElement from "./promotion-element";
import Categoryhead from "../../../components/categoryhead";
import {
  PROMOTION_TOTAL_HEIGHT,
  PROMOTION_TOTAL_WIDTH
} from "./promotionConsts";
import { HeadContainer } from ".";
import styled from "styled-components";

const PromotionGrid = ({ promotions, onHeaderClick }) => {
  const renderPromotionalElement = ({ item }) => {
    const { value, title, description, cover, active, type } = item;
    return (
      <PromotionElement
        value={value}
        title={title}
        description={description}
        cover={cover}
        active={active}
        type={type}
      />
    );
  };

  return (
    <div>
      <PageTitle title={t("promotions.shortcuts", "Shortcuts")} />
      <HeadContainer grid>
        <Categoryhead
          onClick={onHeaderClick}
          label={t("promotions.shortcuts", "Shortcuts")}
          caretLeft={!!onHeaderClick}
        />
      </HeadContainer>
      <GridView
        items={promotions}
        renderItem={renderPromotionalElement}
        baseWidth={PROMOTION_TOTAL_WIDTH}
        baseHeight={PROMOTION_TOTAL_HEIGHT}
        itemKeyProp="value"
      />
    </div>
  );
};

const mapStateToProps = state => {
  return {
    promotions: bridgeSelectors.getPromotions(state)
  };
};

export default connect(mapStateToProps)(withAllMatches(PromotionGrid));
